import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  analyses: {}, // Chiave: idUID, Valore: analisi completa
  currentIdUID: null,
};

const visureAiAnalysisSlice = createSlice({
  name: "visureAiAnalysis",
  initialState,
  reducers: {
    setAiAnalysis: (state, action) => {
      const { idUID, analysis } = action.payload;
      state.analyses[idUID] = analysis;
      state.currentIdUID = idUID;
    },
    clearAiAnalysis: (state, action) => {
      const { idUID } = action.payload;
      if (idUID) {
        delete state.analyses[idUID];
      } else {
        state.analyses = {};
      }
    },
    setCurrentIdUID: (state, action) => {
      state.currentIdUID = action.payload;
    },
    clearAllAnalyses: (state) => {
      state.analyses = {};
      state.currentIdUID = null;
    },
  },
});

export const { setAiAnalysis, clearAiAnalysis, setCurrentIdUID, clearAllAnalyses } =
  visureAiAnalysisSlice.actions;

export default visureAiAnalysisSlice.reducer;
